import { createSelector } from 'reselect';

export const getCollections = state => state.collection && state.collection.collections;
export const getCollectionWithGenericFileSections = state =>
  state.collection && state.collection.collectionWithGenericFileSections;
export const getLoadingCollection = state => state.collection && state.collection.loading;
export const getSelectedCollectionId = state =>
  state.collection && state.collection.selectedCollectionId;

export const getAllCollections = createSelector(
  getCollections,
  collections => collections && collections.ids.map(id => collections.entities[id])
);

export const getSelectedCollection = createSelector(
  [getCollections, getSelectedCollectionId],
  (collections, selectedCollectionId) =>
    collections && collections.entities[selectedCollectionId]
);



// WEBPACK FOOTER //
// ./src/selectors/collection.js